import { Component, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'iot-platform-ui-drag-drop-content',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <ng-template>
      <ng-content />
    </ng-template>
  `
})
export class DragDropContentComponent {
  @ViewChild(TemplateRef, { static: true }) public template!: TemplateRef<unknown>;
}
